let sharedInstance;
export class InternalFeatureService {
    constructor() {
        this.enabledFeatures = new Set();
    }
    static get() {
        if (!sharedInstance) {
            sharedInstance = new InternalFeatureService();
        }
        return sharedInstance;
    }
    isFeatureEnabled(feature) {
        return this.enabledFeatures.has(feature);
    }
    enableFeature(feature) {
        console.warn(`Enabling internal feature: ${feature}`);
        this.enabledFeatures.add(feature);
    }
}
